export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  imageUrl: string;
  thumbUrl: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    slug: 'mitaochengshushi-plot-full-analysis',
    title: '蜜桃成熟时电影完整剧情深度解析',
    excerpt: '《蜜桃成熟时》是1993年上映的香港经典情色喜剧电影，由张肇麟执导，李丽珍主演。本文为您全面解析这部标志性港片的完整剧情脉络与角色关系。',
    content: `<h2>电影概述</h2><p>《蜜桃成熟时》是1993年由香港导演张肇麟执导的一部经典情色喜剧电影，由当时年仅27岁的李丽珍领衔主演。这部电影在香港电影史上具有里程碑式的意义，它不仅是李丽珍从清纯玉女转型性感路线的重要作品，更是90年代香港情色电影浪潮中的标志性代表作。</p><h2>剧情梗概</h2><p>故事围绕女主角阿珍（李丽珍饰）展开，她是一位年轻的都市女性，性格开朗活泼，对爱情和欲望有着自己的追求和理解。影片以轻松幽默的喜剧风格呈现了阿珍在感情世界中的探索与成长，将情欲元素与喜剧元素巧妙融合，创造出一部既大胆又不失温情的作品。</p><h2>角色关系分析</h2><p>影片中阿珍与多位男性角色之间的互动构成了故事的核心线索。每个男性角色都代表着不同的爱情观和人生态度，阿珍在与他们的交往中逐渐认识到自己真正想要的是什么。这种叙事结构在当时具有相当的前卫性，展现了一个女性主动追求自我满足和情感自由的形象。</p><h2>时代背景</h2><p>90年代初的香港正处于回归前夕的特殊历史时期，社会氛围复杂多元。电影分级制度（三级片制度）于1988年实施后，为情色电影提供了合法的市场空间。《蜜桃成熟时》正是在这样的时代背景下诞生，它既顺应了市场需求，又在一定程度上突破了情色电影的套路，注入了更多的人文关怀和艺术追求。</p>`,
    category: 'plot-analysis',
    author: '港片档案馆',
    date: '2026-07-15',
    readTime: '8分钟',
    imageSeq: 'article-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20classic%20movie%20scene%20with%20soft%20warm%20lighting%2C%20nostalgic%201990s%20cinema%20atmosphere%2C%20elegant%20film%20poster%20style%2C%20amber%20and%20golden%20tones%2C%20cinematic%20composition%2C%20vintage%20movie%20aesthetic&width=800&height=500&seq=article-01-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20movie%20poster%20square%20format%2C%20warm%20golden%20tones%2C%20classic%20film%20aesthetic%2C%20nostalgic%20atmosphere&width=200&height=200&seq=article-01-thumb&orientation=squarish',
    tags: ['蜜桃成熟时', '剧情解析', '李丽珍', '90年代港片'],
    featured: true,
  },
  {
    slug: 'li-lizhen-career-and-mitao',
    title: '李丽珍与蜜桃成熟时：从玉女到女神的转型之路',
    excerpt: '李丽珍凭借《蜜桃成熟时》完成了从清纯玉女到性感女神的华丽转身，本文详细回顾她在该片前后的演艺生涯变迁与个人成长。',
    content: `<h2>早期生涯</h2><p>李丽珍1966年出生于香港，1984年通过参加无线电视艺员训练班踏入演艺圈。早期以清纯玉女形象示人，出演了多部青春校园题材的电视剧和电影，如《开心鬼》系列。她甜美的外表和自然的演技赢得了观众的喜爱，但事业发展遇到了瓶颈期。</p><h2>转型契机</h2><p>1993年，27岁的李丽珍接拍了《蜜桃成熟时》，这一决定在当时引起了不小的轰动。从清纯玉女到性感女神的转型，不仅是她个人职业生涯的重大转折，也反映了香港电影市场对女演员多元化形象的需求。</p><h2>表演突破</h2><p>在《蜜桃成熟时》中，李丽珍展现出了远超以往作品的表演层次。她将角色的天真与成熟、羞涩与大胆完美融合，成功塑造了一个立体而鲜活的都市女性形象。这种表演不仅获得了观众的认可，也赢得了影评人的正面评价。</p><h2>后续发展</h2><p>《蜜桃成熟时》的成功为李丽珍打开了更广阔的演艺道路。此后她参演了多部不同类型的电影作品，尝试了更多元化的角色类型。她的这次转型被视为香港电影史上最成功的形象转变之一。</p>`,
    category: 'cast-intro',
    author: '港片档案馆',
    date: '2026-07-10',
    readTime: '6分钟',
    imageSeq: 'article-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20actress%20portrait%20style%20with%20soft%20warm%20lighting%2C%20elegant%201990s%20cinema%20glamour%2C%20vintage%20film%20star%20aesthetic%2C%20amber%20and%20golden%20tones%2C%20classic%20movie%20poster%20composition&width=800&height=500&seq=article-02-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20actress%20portrait%20square%2C%20warm%20golden%20tones%2C%20classic%20film%20star%20aesthetic&width=200&height=200&seq=article-02-thumb&orientation=squarish',
    tags: ['李丽珍', '演员介绍', '蜜桃成熟时', '演艺转型'],
    featured: true,
  },
  {
    slug: 'mitao-behind-scenes-secrets',
    title: '蜜桃成熟时幕后故事：拍摄期间的鲜为人知秘闻',
    excerpt: '《蜜桃成熟时》的拍摄过程充满了有趣的幕后故事，从选角风波到拍摄趣事，本文将为您一一揭晓那些不为人知的片场秘密。',
    content: `<h2>选角过程</h2><p>《蜜桃成熟时》的选角过程并非一帆风顺。据悉，导演张肇麟最初考虑的并不是李丽珍，而是另外几位当时更知名的女演员。然而，由于剧本的特殊性和当时的社会环境，多位女演员都婉拒了邀约。最终，李丽珍在接受邀请后展现出的专业态度和对角色的理解，让导演确信她是最合适的人选。</p><h2>拍摄趣闻</h2><p>影片的拍摄周期约为一个月，期间发生了许多有趣的小故事。据剧组工作人员回忆，李丽珍在拍摄期间表现出了极高的专业素养和敬业精神，她对待每一个镜头都非常认真，力求呈现出最好的效果。影片中许多看似即兴的表演，实际上都经过了精心的设计和反复的排练。</p><h2>导演理念</h2><p>张肇麟导演在拍摄这部电影时有着自己独特的艺术追求。他希望通过情色喜剧这一类型，探讨现代都市男女的情感关系和欲望表达。在导演看来，《蜜桃成熟时》不仅仅是一部情色电影，更是一部关于成长、选择和自我认知的作品。</p>`,
    category: 'behind-scenes',
    author: '港片档案馆',
    date: '2026-07-05',
    readTime: '7分钟',
    imageSeq: 'article-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20movie%20set%20with%20film%20cameras%20and%20warm%20lighting%2C%201990s%20Hong%20Kong%20cinema%20production%20atmosphere%2C%20vintage%20film%20equipment%2C%20amber%20tones%2C%20cinematic%20photography&width=800&height=500&seq=article-03-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Movie%20production%20behind%20scenes%20square%2C%20vintage%20film%20camera%2C%20warm%20lighting%2C%20cinematic&width=200&height=200&seq=article-03-thumb&orientation=squarish',
    tags: ['幕后故事', '拍摄花絮', '蜜桃成熟时', '导演张肇麟'],
    featured: true,
  },
  {
    slug: 'mitao-cultural-significance',
    title: '蜜桃成熟时的文化意义：90年代香港社会的欲望镜像',
    excerpt: '《蜜桃成熟时》不仅是一部娱乐电影，更是一面反映90年代香港社会文化变迁的镜子。本文从文化研究角度分析该片的深层社会意义。',
    content: `<h2>社会背景</h2><p>90年代初的香港社会处于急剧变化的时期。经济高速发展带来了物质生活的极大丰富，但与此同时，传统价值观与现代生活方式之间的碰撞也日益激烈。《蜜桃成熟时》正是在这样的社会背景下诞生的文化产品。</p><h2>女性意识觉醒</h2><p>影片中女主角的塑造体现了90年代香港女性意识的觉醒。女主角不再是传统叙事中被动的欲望对象，而是一个主动追求自我满足和情感自由的主体。这种角色设定在当时具有一定的先锋性，反映了社会对女性角色认知的微妙变化。</p><h2>情色电影的文化价值</h2><p>《蜜桃成熟时》代表了一种将商业娱乐与艺术追求相结合的尝试。它证明了情色电影同样可以承载社会文化意义，而不是简单的感官刺激。这种尝试对后来的香港电影产生了深远的影响。</p>`,
    category: 'cultural-impact',
    author: '港片档案馆',
    date: '2026-06-28',
    readTime: '9分钟',
    imageSeq: 'article-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cityscape%201990s%20with%20warm%20nostalgic%20tones%2C%20neon%20signs%20and%20busy%20streets%2C%20cultural%20atmosphere%2C%20vintage%20photography%20style%2C%20amber%20and%20golden%20lighting&width=800&height=500&seq=article-04-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%201990s%20street%20scene%20square%2C%20neon%20signs%2C%20warm%20golden%20tones%2C%20nostalgic&width=200&height=200&seq=article-04-thumb&orientation=squarish',
    tags: ['文化影响', '90年代香港', '社会变迁', '蜜桃成熟时'],
    featured: false,
  },
  {
    slug: 'mitao-complete-cast-list',
    title: '蜜桃成熟时完整演员表及角色介绍',
    excerpt: '为您整理《蜜桃成熟时》的完整演员阵容，包括主要角色介绍、配角详情及各位演员在片中的精彩表现点评。',
    content: `<h2>主要演员</h2><p><strong>李丽珍 饰 阿珍</strong> — 女主角，一位年轻活泼的都市女性，在爱情和欲望的探索中逐渐成长。李丽珍凭借此角色成功转型，成为90年代香港影坛最具代表性的女演员之一。</p><h2>男主演</h2><p>影片中的男演员们同样贡献了精彩的表演。他们分别饰演了阿珍生命中不同阶段的男性角色，每一个人物都有鲜明的个性和独特的魅力。这些男性角色的塑造，展现了导演对不同类型男性气质的细腻刻画。</p><h2>配角阵容</h2><p>影片的配角阵容同样不可忽视。众多绿叶演员的精彩演绎为影片增色不少，他们在有限的戏份中展现了扎实的表演功底，为整部电影营造了真实而丰富的故事世界。</p>`,
    category: 'cast-intro',
    author: '港片档案馆',
    date: '2026-06-20',
    readTime: '5分钟',
    imageSeq: 'article-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Movie%20cast%20ensemble%20group%20photo%20style%20with%20warm%20lighting%2C%20classic%20Hong%20Kong%20film%20poster%20aesthetic%2C%20elegant%20composition%2C%20amber%20tones%2C%20vintage%20cinema&width=800&height=500&seq=article-05-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Film%20cast%20portrait%20square%2C%20classic%20Hong%20Kong%20cinema%20style%2C%20warm%20tones&width=200&height=200&seq=article-05-thumb&orientation=squarish',
    tags: ['演员表', '角色介绍', '蜜桃成熟时', '李丽珍'],
    featured: false,
  },
  {
    slug: 'mitao-and-hk-cinema-golden-age',
    title: '蜜桃成熟时与香港电影黄金时代的最后余晖',
    excerpt: '90年代是香港电影的黄金时期，也是最后的辉煌。《蜜桃成熟时》作为这一时期的重要作品，见证了港片从巅峰走向转型的历史进程。',
    content: `<h2>港片黄金时代</h2><p>80年代末至90年代中期，香港电影迎来了前所未有的繁荣。年均产量超过200部，类型丰富多样，从动作片到喜剧片，从文艺片到情色片，百花齐放。《蜜桃成熟时》正是在这一黄金时期诞生的代表性作品。</h2><h2>市场环境</h2><p>1993年的香港电影市场正处于巅峰时期。本土市场票房屡创新高，海外市场尤其是东南亚地区对港片的需求持续旺盛。电影分级制度的实施也为情色电影的合法化提供了制度保障。</p><h2>时代意义</h2><p>《蜜桃成熟时》所处的1993年，恰是港片黄金时代的尾声。此后几年，随着好莱坞大片的冲击和亚洲金融风暴的影响，香港电影开始走向衰退。这部电影因此也具有了特殊的历史见证意义。</p>`,
    category: 'cultural-impact',
    author: '港片档案馆',
    date: '2026-06-15',
    readTime: '7分钟',
    imageSeq: 'article-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cinema%20golden%20age%20collage%20with%20film%20strips%20and%20warm%20lighting%2C%20classic%20movie%20posters%20background%2C%20nostalgic%20aesthetic%2C%20amber%20tones&width=800&height=500&seq=article-06-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20film%20golden%20age%20square%20collage%2C%20vintage%20movie%20posters%2C%20warm%20tones&width=200&height=200&seq=article-06-thumb&orientation=squarish',
    tags: ['香港电影', '黄金时代', '蜜桃成熟时', '港片历史'],
    featured: false,
  },
  {
    slug: 'best-90s-hk-films-recommend',
    title: '蜜桃成熟时之后：10部必看90年代经典港片推荐',
    excerpt: '看完《蜜桃成熟时》意犹未尽？本文为您精选10部同样经典的90年代香港电影，涵盖爱情、喜剧、动作等多个类型，带您重温港片辉煌年代。',
    content: `<h2>推荐清单</h2><p>《蜜桃成熟时》是90年代香港电影的一颗明珠，但那个年代还有更多同样精彩的经典之作值得一看。以下是我们为您精选的10部必看港片：</p><h3>1. 《重庆森林》(1994)</h3><p>王家卫导演的经典之作，以独特的视觉风格和碎片化的叙事方式讲述了都市中的孤独与偶遇。</p><h3>2. 《大话西游》(1995)</h3><p>周星驰的巅峰喜剧作品，将爱情与幽默完美结合，成为一代人的集体记忆。</p><h3>3. 《甜蜜蜜》(1996)</h3><p>陈可辛导演的爱情经典，张曼玉和黎明的精彩演绎感动了无数观众。</p>`,
    category: 'film-review',
    author: '港片档案馆',
    date: '2026-06-10',
    readTime: '6分钟',
    imageSeq: 'article-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20classic%20Hong%20Kong%20movie%20DVDs%20and%20posters%20with%20warm%20lighting%2C%20vintage%20film%20collection%20aesthetic%2C%20nostalgic%20atmosphere%2C%20amber%20tones&width=800&height=500&seq=article-07-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20films%20collection%20square%2C%20movie%20DVDs%2C%20warm%20tones%2C%20nostalgic&width=200&height=200&seq=article-07-thumb&orientation=squarish',
    tags: ['港片推荐', '90年代', '经典电影', '蜜桃成熟时'],
    featured: false,
  },
  {
    slug: 'mitao-filming-locations',
    title: '追寻蜜桃成熟时：电影取景地实地探访指南',
    excerpt: '《蜜桃成熟时》中那些经典场景究竟在哪里拍摄？跟随我们的脚步，一同探访这部电影的标志性取景地，感受90年代香港的独特风貌。',
    content: `<h2>取景地概述</h2><p>《蜜桃成熟时》的取景地主要分布在香港岛和九龙半岛的多个地点，这些场景真实记录了90年代香港的城市风貌和街景特色。虽然时过境迁，许多场景已经发生了巨大的变化，但它们通过这部电影得以永远保存。</p><h2>主要场景</h2><p>影片中的街头场景多在旺角、铜锣湾等繁华商业区拍摄，展现了90年代香港作为国际大都市的繁华面貌。而室内的场景则多在香港的私人住宅和摄影棚中完成。</p><h2>今日对比</h2><p>三十年过去了，影片中的许多场景已经发生了翻天覆地的变化。曾经的老街巷变成了现代化的购物中心，旧式的茶餐厅也被连锁品牌取代。这些变化也成为了香港城市发展的缩影。</p>`,
    category: 'behind-scenes',
    author: '港片档案馆',
    date: '2026-06-05',
    readTime: '5分钟',
    imageSeq: 'article-08',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20old%20street%20scene%201990s%20with%20traditional%20shop%20signs%20and%20warm%20lighting%2C%20nostalgic%20urban%20landscape%2C%20vintage%20photography%20style%2C%20amber%20tones&width=800&height=500&seq=article-08-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Old%20Hong%20Kong%20street%20square%2C%20traditional%20shop%20signs%2C%20warm%20nostalgic%20tones&width=200&height=200&seq=article-08-thumb&orientation=squarish',
    tags: ['取景地', '蜜桃成熟时', '香港街景', '90年代香港'],
    featured: false,
  },
  {
    slug: 'mitao-movie-review-professional',
    title: '专业影评：蜜桃成熟时为何能成为跨越时代的经典',
    excerpt: '多位专业影评人从不同角度解读《蜜桃成熟时》的艺术价值和历史地位，探讨这部看似通俗的情色喜剧为何能经受住时间的考验。',
    content: `<h2>影评综述</h2><p>《蜜桃成熟时》上映至今已逾三十年，但它依然被影迷和影评人津津乐道。这部影片之所以能够跨越时代的界限，成为经典，不仅仅因为它的娱乐性和话题性，更在于它独特的艺术表达和文化价值。</p><h2>叙事结构分析</h2><p>影片采用了当时颇为新颖的叙事手法，将女主角的内心世界与外部现实巧妙交织。这种叙事方式既保证了故事的流畅性，又赋予了影片更深层次的情感表达空间。</p><h2>视听语言</h2><p>导演张肇麟在视听语言上展现了独特的才华。影片的色调、构图和剪辑节奏都具有鲜明的90年代港片特色，同时又不乏创新之处。配乐的选择也与影片的情感基调高度契合。</p>`,
    category: 'film-review',
    author: '港片档案馆',
    date: '2026-05-28',
    readTime: '8分钟',
    imageSeq: 'article-09',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20critic%20writing%20with%20warm%20desk%20lamp%20lighting%2C%20movie%20review%20atmosphere%2C%20classic%20Hong%20Kong%20cinema%20posters%20on%20wall%2C%20elegant%20aesthetic%2C%20amber%20tones&width=800&height=500&seq=article-09-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Film%20review%20writing%20square%2C%20warm%20desk%20lamp%2C%20classic%20movie%20atmosphere&width=200&height=200&seq=article-09-thumb&orientation=squarish',
    tags: ['影评', '专业分析', '蜜桃成熟时', '经典电影'],
    featured: false,
  },
  {
    slug: 'mitao-legacy-and-influence',
    title: '蜜桃成熟时的遗产：对后来香港电影行业的影响',
    excerpt: '《蜜桃成熟时》的成功对后来的香港电影行业产生了深远的影响，从创作理念到市场运作，它的遗产延续至今。',
    content: `<h2>行业影响</h2><p>《蜜桃成熟时》的商业成功为香港情色电影树立了一个标杆。它证明了情色题材可以与喜剧元素、人文关怀相结合，创造出既有市场价值又有艺术追求的作品。这种模式被后来的多部电影所借鉴。</p><h2>演员发展</h2><p>影片对演员职业生涯的影响同样深远。李丽珍通过本片成功转型后，获得了更多不同类型的演出机会。她的经历也鼓舞了后来的一批女演员勇于突破自我，尝试多元化的角色类型。</p><h2>文化延续</h2><p>时至今日，《蜜桃成熟时》依然是研究90年代香港电影文化时不可绕开的重要作品。它的文化意义远远超出了一部情色电影的范畴，成为了那个时代香港社会文化的珍贵记录。</p>`,
    category: 'cultural-impact',
    author: '港片档案馆',
    date: '2026-05-20',
    readTime: '6分钟',
    imageSeq: 'article-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20film%20industry%20legacy%20symbolized%20by%20golden%20film%20awards%20and%20trophies%2C%20warm%20spotlight%20lighting%2C%20elegant%20cinema%20atmosphere%2C%20amber%20tones&width=800&height=500&seq=article-10-hero&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Golden%20film%20award%20trophy%20square%2C%20cinema%20legacy%2C%20warm%20lighting&width=200&height=200&seq=article-10-thumb&orientation=squarish',
    tags: ['行业影响', '遗产', '蜜桃成熟时', '香港电影'],
    featured: false,
  },
];

export const featuredArticles = articles.filter((a) => a.featured);

export const getArticlesByCategory = (slug: string): Article[] => {
  return articles.filter((a) => a.category === slug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getRelatedArticles = (article: Article, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.slug !== article.slug && a.category === article.category)
    .slice(0, count);
};